import { MarketMeta, MarketUid } from "@silo/types";
import { Effect, pipe } from "effect";
import { KvClientError, KvService } from "./types";
import { getMarketMetaKey } from "./keys";
import { Schema } from "@effect/schema";

export type GetMarketMetaArray = ReturnType<typeof getMarketMetaArray>;
export type GetMarketMetaArraySuccess =
  Effect.Effect.Success<GetMarketMetaArray>;
export type GetMarketMetaArrayError = Effect.Effect.Error<GetMarketMetaArray>;
export type GetMarketMetaArrayContext =
  Effect.Effect.Context<GetMarketMetaArray>;

export function getMarketMetaArray(marketUids: MarketUid[]) {
  return Effect.gen(function* () {
    if (marketUids.length === 0) return [];

    const kv = yield* KvService;

    const result = yield* Effect.tryPromise({
      try: async () => {
        const pipeline = kv.pipeline();

        for (const { protocolKey, marketAddress } of marketUids) {
          const marketMetaKey = getMarketMetaKey(protocolKey, marketAddress);

          pipeline.json.get(marketMetaKey);
        }

        return pipeline.exec();
      },
      catch: (cause) => new KvClientError({ cause }),
    });

    const marketMetaArray = yield* pipe(
      result,
      Schema.decodeUnknown(Schema.mutable(Schema.Array(MarketMeta)), {
        errors: "all",
      })
    );

    return marketMetaArray;
  });
}
